import React, { Fragment, useEffect, useState } from 'react';
// import Detail from '../page/Detail'
import { Card, Container, CardDeck, Image } from 'react-bootstrap'
import LearnCard from '../components/Card'

const SearchResult = () => {
    
    return (
    <div>
        <LearnCard />
        
    </div>
    )
}

export default SearchResult